export class LoginModel {
  userName!: string;
  password!: string;
}

export class User {
  FullName!: string;
  Token!: string;
  role!: string;
  ImagePath!: string;
  RefreshToken!: string;
  EncodedRefreshToken!: string;
}

export class RegisterModel {
  Name!: string;
  IdentityNumber!: string;
  CityId!: number;
  PhoneNumber!: number;
  PhoneExtension!: number;
  Email!: string;
}
